import { render, staticRenderFns } from "./SubjectListAddNew.vue?vue&type=template&id=ea32cff0&"
import script from "./SubjectListAddNew.vue?vue&type=script&lang=js&"
export * from "./SubjectListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./SubjectListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports